import { createSlice } from '@reduxjs/toolkit'
import { find, difference } from 'lodash'

import { makeRequest } from '../utils/apiUtils';

export const slice = createSlice({
  name: 'backurl',
  initialState: {
    createPage: 1,
    isDeleting: false,
    createOfferList: [],
    erroredOffers: {},
    erroredLandings: {},
    landingList: [],
    createName: '',
    isDefault: false,
    isDefaultError: false,
    isSaving: false,
    isSaved: false,
  },
  reducers: {
    resetForm: (state, action) => {
      state.isDeleting = false;
      state.isDefaultError = false;
      state.isSaving = false;
      state.isSaved = false;
      state.erroredOffers = {};
      state.erroredLandings = {};
    },
    clearForm: (state, action) => {
      state.createOfferList = [];
      state.landingList = [];
      state.createName = '';
      state.isDefault = false;
    },
    deleteItem: (state, action) => {
      state.isDeleting = true;
    },
    deleteItemSuccess: (state, action) => {
      state.isDeleting = false;
    },
    deleteItemFail: (state, action) => {
      state.isDeleting = false;
    },

    clearCreateOfferList: (state, action) => {
      state.createOfferList = [];
      state.erroredOffers = {};
    },

    setCreatePage: (state, action) => {
      state.createPage = action.payload;
    },

    setCreateOfferList: (state, action) => {
      const erroredOfferIds = Object.keys(state.erroredOffers).map(id => +id);
      const diff = difference(erroredOfferIds, action.payload);

      state.createOfferList = action.payload;
      diff.forEach(id => {
        delete state.erroredOffers[id];
      });
    },

    setLandingList: (state, action) => {
      state.landingList = action.payload
    },

    toggleLanding: (state, action) => {
      const landingId = +(action.payload.url_id ?? action.payload.id);
      if (find(state.landingList, {url_id: landingId})) {
        state.landingList = state.landingList.filter(({url_id}) => +url_id !== landingId);
        delete state.erroredLandings[landingId];
      } else {
        state.landingList.push({
          ...action.payload,
          url_id: +action.payload.id
        });
      }
    },

    deleteLanding: (state, action) => {
      const landingId = +action.payload;
      state.landingList = state.landingList.filter(({url_id}) => +url_id !== landingId);
      delete state.erroredLandings[landingId];
    },

    setCreateName: (state, action) => {
      state.createName = action.payload;
    },

    setIsDefault: (state, action) => {
      state.isDefault = action.payload;
    },

    saveData: (state, action) => {
      state.isSaving = true;
      state.isSaved = false;
    },

    saveDataSuccess: (state, action) => {
      state.isSaving = false;
      state.isSaved = true;
    },

    saveDataFail: (state, action) => {
      state.isSaving = false;
      state.isSaved = false;
      const form_errors = action.response?.data?.form_errors;

      state.isDefaultError = !!form_errors?.is_default;

      if (form_errors) {

        if (form_errors.offers) {
          state.erroredOffers = form_errors.offers.reduce((prev, next) => {
            const data = next.split(':');
            return ({...prev, [data[0]]: data[1]})
          }, {});
        }

        if (form_errors.url_chain) {
          state.erroredLandings = form_errors.url_chain.reduce((prev, next) => {
            const data = next.split(':');
            return ({...prev, [data[0]]: data[1]})
          }, {});
        }

      }

    },

    removeErroredOffers: state => {
      const erroredOffers = Object.keys(state.erroredOffers).map(id => +id);
      state.createOfferList = state.createOfferList.filter(id => !erroredOffers.includes(+id));
      state.erroredOffers = {};
    },

    removeErroredLandings: state => {
      const erroredLandings = Object.keys(state.erroredLandings).map(id => +id);
      state.landingList = state.landingList.filter(item => !erroredLandings.includes(+item.url_id));
      state.erroredLandings = {};
    }
  }
});

export const {
  deleteItem,
  deleteItemSuccess,
  deleteItemFail,
  clearCreateOfferList,
  setCreatePage,
  setCreateName,
  setCreateOfferList,
  setIsDefault,
  setLandingList,
  toggleLanding,
  deleteLanding,
  resetForm,
  clearForm,
  removeErroredOffers,
  removeErroredLandings,

  saveData,
  saveDataSuccess,
  saveDataFail,
} = slice.actions;

export const selectCreatePage = state => state.backurl.createPage;
export const selectIsDeleting = state => state.backurl.isDeleting;
export const selectCreateOfferList = state => state.backurl.createOfferList;
export const selectIsDefault = state => state.backurl.isDefault;
export const selectIsDefaultError = state => state.backurl.isDefaultError;
export const selectLandingList = state => state.backurl.landingList;
export const selectCreateName = state => state.backurl.createName;
export const selectIsSaved = state => state.backurl.isSaved;
export const selectErroredOffers = state => state.backurl.erroredOffers;
export const selectErroredLandings = state => state.backurl.erroredLandings;

export function saveBackurl(id = false, data, change_default) {
  return makeRequest(`/saduka/backurls/${isNaN(id) ? '' : id}?` + (change_default ? 'change_default=true' : ''), {
    types: [saveData.type, saveDataSuccess.type, saveDataFail.type],
    options: {
      credentials: 'include',
      method: id ? 'PATCH' : 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    },
  })
}

export function deleteBackurl(id) {
  return makeRequest(`/saduka/backurls/${id}`, {
    types: [deleteItem.type, deleteItemSuccess.type, deleteItemFail.type],
    options: {
      credentials: 'include',
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json'
      },
    },
  })
}

export default slice.reducer;
